// extracted by mini-css-extract-plugin
export var phraseHolder = "style-module--phraseHolder---6MvH";
export var phrase = "style-module--phrase--Q6QXS";
export var animate = "style-module--animate--8JCMP";